import React, { useEffect, useRef, useState } from 'react'
import { IEnquiry } from '../../../models/Enquiry'
import Conditional from '../../common/Conditional'

const TellUsMoreStepOne = React.lazy(
  () => import('../enquiry-steps/TellUsMoreStepOne')
)
const TellUsMoreStepTwo = React.lazy(
  () => import('../enquiry-steps/TellUsMoreStepTwo')
)
const TellUsMoreStepReview = React.lazy(
  () => import('../enquiry-steps/TellUsMoreStepReview')
)
const TellUsMoreConfirmationStep = React.lazy(
  () => import('../enquiry-steps/TellUsMoreConfirmationStep')
)
const TellUsMoreStepFinish = React.lazy(
  () => import('../enquiry-steps/TellUsMoreStepFinish')
)

export interface IEnquiryLodgementWizardStepRenderer {
  step: number
  enquiry?: IEnquiry
  reset: () => void
  onError: (error: any) => void
}

const EnquiryLodgementWizardStepRenderer = (
  props: IEnquiryLodgementWizardStepRenderer
) => {
  const mountedRef = useRef(false)
  const [activeStep, setActiveStep] = useState<number>(0)
  const [enquiry, setEnquiry] = useState<IEnquiry>()

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      setActiveStep(props.step)
      props.enquiry.businessABN = props.enquiry.businessABN.replace(/ /g, '')
      setEnquiry(props.enquiry)
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.step])

  const renderStep = () => {
    switch (activeStep) {
      case 1:
        return (
          <TellUsMoreStepOne
            showreadonly={false}
            enquiry={enquiry}
            onError={props.onError}
          />
        )
      case 2:
        return (
          <TellUsMoreStepTwo
            showreadonly={false}
            enquiry={enquiry}
            onError={props.onError}
          />
        )
      case 3:
        return (
          <>
            <TellUsMoreStepReview
              enquiry={enquiry}
              showreadonly={true}
              onError={props.onError}
            />
            <TellUsMoreConfirmationStep
              enquiry={enquiry}
              startOver={props.reset}
            />
          </>
        )
      case 4:
        return <TellUsMoreStepFinish />
      default:
        return null
    }
  }

  return (
    <>
      <Conditional if={activeStep > 0}>{renderStep()}</Conditional>
    </>
  )
}

export default EnquiryLodgementWizardStepRenderer
